module.exports = __webpack_public_path__ + "static/img/logotitle.d9272484.png";